import moment from 'moment';
import Tooltip from '@mui/material/Tooltip';
import { partnersInfo } from 'utils/general';
import { formatPolicyStatus, formatCancellationSubstatusLabel } from 'utils/policyStatus';
import { formatCPF, formatPlate } from 'react-data-formatter';
import { formatCurrency } from 'react-data-formatter';
import { translatePolicyModality } from 'utils/policyModality';

export const dataColumns = [
  {
    selector: (row) => (
      <Tooltip title={`${partnersInfo[partnersInfo.findIndex((i) => i.id_partner === row?.partner?.id)]?.name}`}>
        <img
          className="partnerIcon"
          src={partnersInfo[partnersInfo.findIndex((i) => i.id_partner === row?.partner?.id)]?.logos?.small}
          alt={partnersInfo[partnersInfo.findIndex((i) => i.id_partner === row?.partner?.id)]?.name}
        />
      </Tooltip>
    ),
    width: '5%',
    sortable: true,
  },
  {
    name: 'MGA',
    selector: (row) => row?.partner?.trade_name ?? '—',
    width: '10%',
    sortable: true,
  },
  {
    name: 'ID',
    selector: (row) => row?.id,
    width: '7%',
    sortable: true,
  },
  {
    name: 'Cliente',
    selector: (row) => row?.user?.name,
    width: '13%',
    sortable: true,
  },
  {
    name: 'CPF',
    selector: (row) => formatCPF(row?.user?.cpf),
    width: '10%',
    sortable: true,
  },
  {
    name: 'Placa',
    selector: (row) => formatPlate(row?.vehicle?.plate) || 'Sem placa',
    width: '10%',
    sortable: true,
  },
  {
    name: 'Valor',
    selector: (row) => formatCurrency(row?.value_final || 0),
    width: '10%',
    sortable: true,
  },
  {
    name: 'Status',
    selector: (row) => formatPolicyStatus(row?.status)?.label,
    width: '10%',
    sortable: true,
  },
  {
    name: 'Modalidade',
    selector: (row) => translatePolicyModality(row?.policy_modality),
    width: '10%',
    sortable: true,
  },
  {
    name: 'Substatus',
    selector: (row) => {
      if (row?.status !== 'canceled') return '—';
      return formatCancellationSubstatusLabel(row?.substatus) || '—';
    },
    width: '10%',
    sortable: true,
  },
  {
    name: 'Enviada em',
    selector: (row) => moment.utc(row?.created_at).format('DD/MM/YYYY HH:mm'),
    width: '10%',
    sortable: true,
  },
];
